import createIsInvalid from './selectors/isInvalid';
import plain from './structure/plain';

export default createIsInvalid(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/isInvalid.js
// module id = 2062
// module chunks = 0